/**
 * @namespace app.ui
 * @description
 *
 * The `app.ui` module pull in all the inidividual ui modules.
 */
// TODO: refactor to flatten the app.ui module
angular.module('app.ui', []);
